import { NavLink } from "react-router-dom"
import MenuCommon from "./SidebarMenuCommon"

function MenuInteractive() {
  return (
    <>
      <MenuCommon />
      <li className="nav-header">Écran interactif</li>
      <li className="nav-item">
        <NavLink to="/interactif/menus" className="nav-link">
          <i className="nav-icon fas fa-hand-pointer" />
          <p>Menus interactifs</p>
        </NavLink>
      </li>
    </>
  )
}

export default MenuInteractive
